<template>
  <div class="outer">
      <div class="wrap">
        <div id="login">
          <div id="header">
            <div class="logo-jhome">               
              <span class="j1"></span>
              <span class="j2"></span>
              <span class="j3"></span>
              <span class="j4"></span>
              <span class="j5"></span>
              <span class="ha1"></span>
              <span class="ha2"></span>
            </div>
          <div class="middle"><span>Lebenslauf</span></div>
          </div>
          <div id="content"> 
              <div v-if="loginerror == true">{{error_msg}}</div>
              <input tabindex="1" ref="password" type="password" name="password" @keyup.exact="keyup" @keyup.enter="login" v-model="password" placeholder="Passwort"/>
              <button tabindex="2" class="btn anmelden" v-on:click="login">ANMELDEN</button>              
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      msg: 'Login Page',
      loginname: '',
      password: '',
      loginerror: false,
      error_msg: ''
    }  
  },
  methods: {
    login: function (event) {
      if(this.password.length == 0){
        this.loginerror = true;
        this.error_msg = 'Passwort fehlt'
        return;
      }
      this.$http.post('/api/login.pl', { loginname: this.loginname, password: this.password }, {headers: {'Content-Type': 'application/json'}}).then(function (response) {
        this.user = response.data
        if( this.user.logged_in == 1 ){
          this.$router.push({ name: 'lebenslauf' }) 
        }
      });  
    },
    keyup: function (event) {
      this.loginerror = false
      this.error_msg = ''

    }
  },
  mounted() {
    this.$refs.password.focus()
  },
}
</script>



// WEBPACK FOOTER //
// src/admin/Login.vue